/**
 * Lazy font loading strategy
 * 
 * Loads fonts only when needed based on active language
 * Prevents loading both English and Arabic fonts by default
 */

const fonts = {
  en: {
    family: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
    url: null // Use system fonts or already loaded fonts
  },
  ar: {
    family: '"Cairo", "Tahoma", "Arial", sans-serif',
    url: 'https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap'
  }
};

/**
 * Load font for specific language
 * @param {string} language - Language code ('en' or 'ar')
 */
export const loadFontForLanguage = (language) => {
  const font = fonts[language] || fonts.en;
  
  // Update CSS custom property
  if (typeof document !== 'undefined') {
    document.documentElement.style.setProperty('--font-family', font.family);
    
    // Load font stylesheet if URL provided and not already loaded
    if (font.url) {
      const existingLink = document.querySelector(`link[href="${font.url}"]`);
      
      if (!existingLink) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = font.url;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    }
  }
};

/**
 * Preload font for faster switching
 * @param {string} language - Language code to preload
 */
export const preloadFont = (language) => {
  const font = fonts[language];
  if (font && font.url && typeof document !== 'undefined') {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'style';
    link.href = font.url;
    document.head.appendChild(link);
  }
};

/**
 * Get font family for language
 * @param {string} language - Language code
 * @returns {string} - Font family string
 */
export const getFontFamily = (language) => {
  const font = fonts[language] || fonts.en;
  return font.family;
};

